import React, {useState} from 'react';
import {Form, Input} from 'antd';
import {MailOutlined, LockOutlined} from '@ant-design/icons';
import {useAppDispatch, useAppState} from '@nutastic/nutastic-react-app';
import {forgotPasswordRequest, logIntoApplication} from '../../../../state/actions.mjs';
import classnames from "classnames";

const componentClass = 'loginForm';

export const LoginForm = ({ emailValue, onLoginComplete, onCancel, hideEmailField }) => {
    const classes = classnames(componentClass, 'nuAntForm');
    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const appDispatch = useAppDispatch();
    const {
        authState: {
            isProcessingLogin,
            isAuthenticated,
            authError
        } = {}
    } = useAppState();

    const initialCredentials = {
        email: emailValue || '',
        password: ''
    };

    const onCancelClick = () => {
        if (showPasswordReset) {
            setShowPasswordReset(false)
        } else {
            onCancel && onCancel();
        }
    };

    const onLoginSubmit = ({email, password}) => {
        const emailToUse = hideEmailField ? emailValue : email;
        appDispatch(logIntoApplication({email: emailToUse, password, onSuccess: onLoginComplete}));
    };

    const loginFormMessage = <div>
        <h2>Log In</h2>
        { hideEmailField && <p className="mb-1">You are logging in as <b>{ emailValue }</b>.</p>}
        <p>Hope you brought your cool credentials to get in the club!</p>
    </div>;

    const loginForm = <Form layout="vertical" initialValues={initialCredentials} onFinish={onLoginSubmit}>
        { !hideEmailField &&
            <Form.Item size={"large"} name="email" rules={[{ required: true, message: 'Enter your email', type: "email" }]}>
                <Input prefix={<MailOutlined className="text-primary"/>} placeholder="user@nutastic.net"/>
            </Form.Item>
        }
        <Form.Item size={"large"} name="password" rules={[{ required: true, message: 'Enter your password' }]}>
            <Input.Password prefix={<LockOutlined className="text-primary"/>} placeholder="Enter Password"/>
        </Form.Item>
        <div className="text-center">
            <Form.Item className="mt-5">
                <button type={"submit"} className="btn btn-dark-red btn-block" disabled={isAuthenticated || isProcessingLogin}>Login</button>
            </Form.Item>
        </div>
    </Form>;

    const onForgotPasswordSubmit = ({ email }) => {
        appDispatch(forgotPasswordRequest({ email }));
    };

    const forgotPasswordMessage = <div>
        <h2>Reset Your Password</h2>
        <p>Please send an email to service@nutastic.net from the email address that you registered with. We will reset your password and send you credentials to log in with.</p>
    </div>;

    const forgotPasswordForm = <Form layout="vertical" initialValues={initialCredentials} onFinish={onForgotPasswordSubmit}>
        <Form.Item size={"large"} name="email" rules={[{ required: true, message: 'Please input your email', type: "email" }]}>
            <Input prefix={<MailOutlined className="text-primary"/>} placeholder="user@nutastic.net"/>
        </Form.Item>
        <Form.Item className="mt-5">
            <button type={"submit"} className="btn btn-primary" disabled={isAuthenticated || isProcessingLogin}>Reset Password</button>
        </Form.Item>
    </Form>

    return <div className={classes}>
        { showPasswordReset ? forgotPasswordMessage : loginFormMessage }
        { authError && <div className={`${componentClass}__error`}>{authError}</div> }
        <div className={`${componentClass}__form`}>
            { showPasswordReset ? null : loginForm }
        </div>
        { (onCancel || showPasswordReset) && <div className="linkTextButton mt-5" onClick={onCancelClick}>Go Back</div> }
        { !showPasswordReset && <div className="linkTextButton mt-4" onClick={() => setShowPasswordReset(true)}>Did you forget the password again?</div> }
    </div>;
};

export default LoginForm;
